import styles from "./privacy.module.scss";
import * as React from "react";
import Header from "@components/Header";
import useIntersectionObserver from "src/hooks/useIntersectionObserver";

type Props = {};

const Privacy: React.FC<Props> = (props) => {
  const ref = React.useRef<HTMLDivElement | null>(null);
  const entry = useIntersectionObserver(ref, {});
  const isVisible = !!entry?.isIntersecting;
  const ref2 = React.useRef<HTMLDivElement | null>(null);
  const entry2 = useIntersectionObserver(ref2, {});
  const isVisible2 = !!entry2?.isIntersecting;
  const ref3 = React.useRef<HTMLDivElement | null>(null);
  const entry3 = useIntersectionObserver(ref3, {});
  const isVisible3 = !!entry3?.isIntersecting;
  const ref4 = React.useRef<HTMLDivElement | null>(null);
  const entry4 = useIntersectionObserver(ref4, {});
  const isVisible4 = !!entry4?.isIntersecting;
  const ref5 = React.useRef<HTMLDivElement | null>(null);
  const entry5 = useIntersectionObserver(ref5, {});
  const isVisible5 = !!entry5?.isIntersecting;
  const ref6 = React.useRef<HTMLDivElement | null>(null);
  const entry6 = useIntersectionObserver(ref6, {});
  const isVisible6 = !!entry6?.isIntersecting;
  const ref7 = React.useRef<HTMLDivElement | null>(null);
  const entry7 = useIntersectionObserver(ref7, {});
  const isVisible7 = !!entry7?.isIntersecting;
  const ref8 = React.useRef<HTMLDivElement | null>(null);
  const entry8 = useIntersectionObserver(ref8, {});
  const isVisible8 = !!entry8?.isIntersecting;
  const ref9 = React.useRef<HTMLDivElement | null>(null);
  const entry9 = useIntersectionObserver(ref9, {});
  const isVisible9 = !!entry9?.isIntersecting;
  const ref10 = React.useRef<HTMLDivElement | null>(null);
  const entry10 = useIntersectionObserver(ref10, {});
  const isVisible10 = !!entry10?.isIntersecting;
  const ref11 = React.useRef<HTMLDivElement | null>(null);
  const entry11 = useIntersectionObserver(ref11, {});
  const isVisible11 = !!entry11?.isIntersecting;
  const ref12 = React.useRef<HTMLDivElement | null>(null);
  const entry12 = useIntersectionObserver(ref12, {});
  const isVisible12 = !!entry12?.isIntersecting;
  const ref13 = React.useRef<HTMLDivElement | null>(null);
  const entry13 = useIntersectionObserver(ref13, {});
  const isVisible13 = !!entry13?.isIntersecting;
  const ref14 = React.useRef<HTMLDivElement | null>(null);
  const entry14 = useIntersectionObserver(ref14, {});
  const isVisible14 = !!entry14?.isIntersecting;
  const ref15 = React.useRef<HTMLDivElement | null>(null);
  const entry15 = useIntersectionObserver(ref15, {});
  const isVisible15 = !!entry15?.isIntersecting;
  const ref16 = React.useRef<HTMLDivElement | null>(null);
  const entry16 = useIntersectionObserver(ref16, {});
  const isVisible16 = !!entry16?.isIntersecting;
  const ref17 = React.useRef<HTMLDivElement | null>(null);
  const entry17 = useIntersectionObserver(ref17, {});
  const isVisible17 = !!entry17?.isIntersecting;
  const ref18 = React.useRef<HTMLDivElement | null>(null);
  const entry18 = useIntersectionObserver(ref18, {});
  const isVisible18 = !!entry18?.isIntersecting;
  const ref19 = React.useRef<HTMLDivElement | null>(null);
  const entry19 = useIntersectionObserver(ref19, {});
  const isVisible19 = !!entry19?.isIntersecting;
  const ref20 = React.useRef<HTMLDivElement | null>(null);
  const entry20 = useIntersectionObserver(ref20, {});
  const isVisible20 = !!entry20?.isIntersecting;
  const ref21 = React.useRef<HTMLDivElement | null>(null);
  const entry21 = useIntersectionObserver(ref21, {});
  const isVisible21 = !!entry21?.isIntersecting;
  const scrollRef = React.useRef<HTMLLIElement | null>(null);
  const scrollRef2 = React.useRef<HTMLLIElement | null>(null);

  React.useEffect(() => {
    if (scrollRef.current && scrollRef2.current !== null) {
      if (isVisible) {
        scrollRef.current.scrollIntoView();
      } else if (isVisible21) {
        scrollRef2.current.scrollIntoView();
      }
    }
  }, [isVisible, isVisible21]);

  return (
    <div className={styles["privacy"]} data-scroll-section>
      <Header />

      <div className={styles["privacy__top"]}>
        <h1 className={styles["privacy__top__heading"]}>Privacy Policy</h1>
        <p className={styles["privacy__top__sub"]}>
          Last Updated : 20th February 2023
        </p>
      </div>

      <div className={styles["privacy__container"]}>
        <div className={styles["privacy__left"]}>
          <h4>Page Guide</h4>

          <ol>
            <li
              style={
                isVisible ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
              ref={scrollRef}
            >
              <a href="#introduction">1. Introduction</a>
            </li>
            <li
              style={
                isVisible2 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#definitions">2. Definitions</a>
            </li>
            <li
              style={
                isVisible3 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#information">3. Information Collection and Use</a>
            </li>
            <li
              style={
                isVisible4 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#data-collected">4. Types of Data Collected</a>
            </li>
            <li
              style={
                isVisible5 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#use-of-data">5. Use of Data</a>
            </li>
            <li
              style={
                isVisible6 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#data-retention">6. Retention of Data</a>
            </li>
            <li
              style={
                isVisible7 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#data-transfer">7. Transfer of Data</a>
            </li>
            <li
              style={
                isVisible8 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#data-disclosure">8. Disclosure of Data</a>
            </li>
            <li
              style={
                isVisible9 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#data-security">9. Security of Data</a>
            </li>
            <li
              style={
                isVisible10 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#data-protection-GDPR">
                10. Your Data Protection Rights Under General Data Protection
                Regulation (GDPR)
              </a>
            </li>
            <li
              style={
                isVisible11 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#data-protection-CalOPPA">
                11. Your Data Protection Rights under the California Privacy
                Protection Act (CalOPPA)
              </a>
            </li>
            <li
              style={
                isVisible12 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#data-protection-CCPA">
                12. Your Data Protection Rights under the California Consumer
                Privacy Act (CCPA)
              </a>
            </li>
            <li
              style={
                isVisible13 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#service-providers">13. Service Providers</a>
            </li>
            <li
              style={
                isVisible14 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#analytics">14. Analytics</a>
            </li>
            <li
              style={
                isVisible15 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#cicd-tools">15. CI/CD tools</a>
            </li>
            <li
              style={
                isVisible16 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#behavioural-remarketing">16. Behavioural Remarketing</a>
            </li>
            <li
              style={
                isVisible17 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#payments">17. Payments</a>
            </li>
            <li
              style={
                isVisible18 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#links-to-sites">18. Links to Other Sites</a>
            </li>
            <li
              style={
                isVisible19 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#children-privacy">19. Children&apos;s Privacy</a>
            </li>
            <li
              style={
                isVisible20 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#privacy-policy-changes">
                20. Changes to This Privacy Policy
              </a>
            </li>
            <li
              style={
                isVisible21 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
              ref={scrollRef2}
            >
              <a href="#contact-us">21. Contact Us</a>
            </li>
          </ol>
        </div>

        <div className={styles["privacy__right"]}>
          <h2
            id="introduction"
            ref={(element) => {
              ref.current = element;
            }}
          >
            1. Introduction
          </h2>
          <p>
            Welcome to Inawo.
            <br />
            <br />
            Inawo (“us”, “we”, or “our”) operates Inawo.com (hereinafter
            referred to as “Service”).
            <br />
            Our Privacy Policy governs your visit to Inawo.com, and explains how
            we collect, safeguard and disclose information that results from
            your use of our Service.
            <br />
            <br />
            We use your data to provide and improve Service. By using Service,
            you agree to the collection and use of information in accordance
            with this policy. Unless otherwise defined in this Privacy Policy,
            the terms used in this Privacy Policy have the same meanings as in
            our Terms and Conditions.
            <br />
            <br />
            Our Terms and Conditions (“Terms”) govern all use of our Service and
            together with the Privacy Policy constitutes your agreement with us
            (“agreement”).
          </p>

          <h2
            id="definitions"
            ref={(element) => {
              ref2.current = element;
            }}
          >
            2. Definitions
          </h2>
          <p>
            <span className="bold">SERVICE</span> means the Inawo.com website
            operated by Inawo.
            <br />
            <br />
            <span className="bold">PERSONAL DATA</span> means data about a
            living individual who can be identified from those data (or from
            those and other information either in our possession or likely to
            come into our possession).
            <br />
            <br />
            <span className="bold">USAGE DATA</span> is data collected
            automatically either generated by the use of Service or from Service
            infrastructure itself (for example, the duration of a page visit).
            <br />
            COOKIES are small files stored on your device (computer or mobile
            device).
            <br />
            <br />
            <span className="bold">DATA CONTROLLER</span> means a natural or
            legal person who (either alone or jointly or in common with other
            persons) determines the purposes for which and the manner in which
            any personal data are, or are to be, processed. For the purpose of
            this Privacy Policy, we are a Data Controller of your data.
            <br />
            <br />
            <span className="bold">
              DATA PROCESSORS (OR SERVICE PROVIDERS)
            </span>{" "}
            means any natural or legal person who processes the data on behalf
            of the Data Controller. We may use the services of various Service
            Providers in order to process your data more effectively.
            <br />
            <br />
            <span className="bold">DATA SUBJECT</span> is any living individual
            who is the subject of Personal Data. THE USER is the individual
            using our Service. The User corresponds to the Data Subject, who is
            the subject of Personal Data.
          </p>

          <h2
            id="information"
            ref={(element) => {
              ref3.current = element;
            }}
          >
            3. Information Collection and Use
          </h2>
          <p>
            We collect several different types of information for various
            purposes to provide and improve our Service to you
          </p>

          <h2 id="data-collected">4. Types of Data Collected</h2>
          <p
            ref={(element) => {
              ref4.current = element;
            }}
          >
            <span className="bold">Personal Data</span>
            <br />
            While using our Service, we may ask you to provide us with certain
            personally identifiable information that can be used to contact or
            identify you (“Personal Data”). Personally identifiable information
            may include, but is not limited to:
            <br />
            0.1. Email address
            <br />
            0.2. First name and last name
            <br />
            0.3. Phone number
            <br />
            0.4. Address, Country, State, Province, ZIP/Postal code, City
            <br />
            0.5. Cookies and Usage Data
            <br />
            <br />
            We may use your Personal Data to contact you with notifications,
            newsletters, marketing or promotional materials and other
            information that may be of help or interest to you through whatsapp,
            emails, sms or any other means of communication.
            <br />
            However, you may opt out of receiving any, or all of these
            communications from us by following the unsubscribe link or by
            emailing at hello@inawo.co.
            <br />
            <br />
            <span className="bold">Usage Data</span>
            <br />
            We may also collect information that your browser sends whenever you
            visit our Service or when you access Service by or through any
            device (“Usage Data”). This Usage Data may include information such
            as your computer’s Internet Protocol address (e.g. IP address),
            browser type, browser version, the pages of our Service that you
            visit, the time and date of your visit, the time spent on those
            pages, unique device identifiers and other diagnostic data.
            <br />
            <br />
            When you access Service with a device, this Usage Data may include
            information such as the type of device you use, your device unique
            ID, the IP address of your device, your device operating system, the
            type of Internet browser you use, unique device identifiers and
            other diagnostic data.
            <br />
            <br />
            <span className="bold">Location Data</span>
            <br />
            We may use and store information about your location if you give us
            permission to do so (“Location Data”). We use this data to provide
            features of our Service, to improve and customise our Service.
            <br />
            You can enable or disable location services when you use our Service
            at any time by way of your device settings.
            <br />
            <br />
            <span className="bold">Tracking Cookies Data</span>
            <br />
            We use cookies and similar tracking technologies to track the
            activity on our Service and we hold certain information.
            <br />
            <br />
            Cookies are files with a small amount of data which may include an
            anonymous unique identifier. Cookies are sent to your browser from a
            website and stored on your device. Other tracking technologies are
            also used such as beacons, tags and scripts to collect and track
            information and to improve and analyse our Service.
            <br />
            <br />
            You can instruct your browser to refuse all cookies or to indicate
            when a cookie is being sent. However, if you do not accept cookies,
            you may not be able to use some portions of our Service.
            <br />
            Examples of Cookies we use:
            <br />
            0.1. <span className="bold">Session Cookies</span>: We use Session
            Cookies to operate our Service.
            <br />
            0.2. <span className="bold">Preference Cookies</span>: We use
            Preference Cookies to remember your preferences and various
            settings.
            <br />
            0.3. <span className="bold">Security Cookies</span>: We use Security
            Cookies for security purposes.
            <br />
            0.4. <span className="bold">Advertising Cookies</span>: Advertising
            Cookies are used to serve you with advertisements that may be
            relevant to you and your interests.
            <br />
            <br />
            <span className="bold">Other Data</span>
            <br />
            While using our Service, we may also collect the following
            information: sex, age, date of birth, place of birth, passport
            details, citizenship, registration at place of residence and actual
            address, telephone number (work, mobile), details of documents on
            education, qualification, professional training, employment
            agreements, information on bonuses and compensation, information on
            marital status, family members, social security (or other taxpayer
            identification) number, office location and other data.
          </p>

          <h2 id="use-of-data">5. Use of Data</h2>
          <p
            ref={(element) => {
              ref5.current = element;
            }}
          >
            Inawo uses the collected data for various purposes:
            <br />
            0.1. to provide and maintain our Service;
            <br />
            0.2. to notify you about changes to our Service;
            <br />
            0.3. to allow you to participate in interactive features of our
            Service when you choose to do so;
            <br />
            0.4. to provide customer support;
            <br />
            0.5. to gather analysis or valuable information so that we can
            improve our Service;
            <br />
            0.6. to monitor the usage of our Service;
            <br />
            0.7. to detect, prevent and address technical issues;
            <br />
            0.8. to fulfil any other purpose for which you provide it;
            <br />
            0.9. to carry out our obligations and enforce our rights arising
            from any contracts entered into between you and us, including for
            billing and collection;
            <br />
            0.10. to provide you with notices about your account and/or
            subscription, including expiration and renewal notices,
            email-instructions, etc.;
            <br />
            0.11. to provide you with news, special offers and general
            information about other goods, services and events which we offer
            that are similar to those that you have already purchased or
            enquired about unless you have opted not to receive such
            information;
            <br />
            0.12. in any other way we may describe when you provide the
            information;
            <br />
            0.13. for any other purpose with your consent.
          </p>

          <h2 id="data-retention">6. Retention of Data</h2>
          <p
            ref={(element) => {
              ref6.current = element;
            }}
          >
            We will retain your Personal Data only for as long as is necessary
            for the purposes set out in this Privacy Policy. We will retain and
            use your Personal Data to the extent necessary to comply with our
            legal obligations (for example, if we are required to retain your
            data to comply with applicable laws), resolve disputes, and enforce
            our legal agreements and policies.
            <br />
            <br />
            We will also retain Usage Data for internal analysis purposes. Usage
            Data is generally retained for a shorter period, except when this
            data is used to strengthen the security or to improve the
            functionality of our Service, or we are legally obligated to retain
            this data for longer time periods.
          </p>

          <h2 id="data-transfer">7. Transfer of Data</h2>
          <p
            ref={(element) => {
              ref7.current = element;
            }}
          >
            Your information, including Personal Data, may be transferred to –
            and maintained on – computers located outside of your state,
            province, country or other governmental jurisdiction where the data
            protection laws may differ from those of your jurisdiction.
            <br />
            <br />
            If you are located outside Nigeria and choose to provide information
            to us, please note that we transfer the data, including Personal
            Data, to Nigeria and process it there.
            <br />
            <br />
            Your consent to this Privacy Policy followed by your submission of
            such information represents your agreement to that transfer.
            <br />
            <br />
            Inawo will take all the steps reasonably necessary to ensure that
            your data is treated securely and in accordance with this Privacy
            Policy and no transfer of your Personal Data will take place to an
            organisation or a country unless there are adequate controls in
            place including the security of your data and other personal
            information.
          </p>

          <h2 id="data-disclosure">8. Disclosure of Data</h2>
          <p
            ref={(element) => {
              ref8.current = element;
            }}
          >
            We may disclose personal information that we collect, or you
            provide:
            <br />
            0.1. <span className="bold">Disclosure for Law Enforcement</span>
            <br />
            Under certain circumstances, we may be required to disclose your
            Personal Data if required to do so by law or in response to valid
            requests by public authorities.
            <br />
            0.2. <span className="bold">Business Transaction</span>
            <br />
            If we or our subsidiaries are involved in a merger, acquisition or
            asset sale, your Personal Data may be transferred.
            <br />
            0.3.{" "}
            <span className="bold">
              Other cases. We may disclose your information also:
            </span>
            <br />
            0.3.1. to our subsidiaries and affiliates;
            <br />
            0.3.2. to contractors, service providers, and other third parties we
            use to support our business;
            <br />
            0.3.3. to fulfil the purpose for which you provide it;
            <br />
            0.3.4. for the purpose of including your company&apos;s logo on our
            website;
            <br />
            0.3.5. for any other purpose disclosed by us when you provide the
            information;
            <br />
            0.3.6. with your consent in any other cases;
            <br />
            0.3.7. if we believe disclosure is necessary or appropriate to
            protect the rights, property, or safety of the Company, our
            customers, or others.
          </p>

          <h2 id="data-security">9. Security of Data</h2>
          <p
            ref={(element) => {
              ref9.current = element;
            }}
          >
            The security of your data is important to us but remember that no
            method of transmission over the Internet or method of electronic
            storage is 100% secure. While we strive to use commercially
            acceptable means to protect your Personal Data, we cannot guarantee
            its absolute security.
          </p>

          <h2 id="data-protection-GDPR">
            10. Your Data Protection Rights Under General Data Protection
            Regulation (GDPR)
          </h2>
          <p
            ref={(element) => {
              ref10.current = element;
            }}
          >
            If you are a resident of the European Union (EU) and European
            Economic Area (EEA), you have certain data protection rights,
            covered by GDPR.
            <br />
            <br />
            We aim to take reasonable steps to allow you to correct, amend,
            delete, or limit the use of your Personal Data.
            <br />
            <br />
            If you wish to be informed what Personal Data we hold about you and
            if you want it to be removed from our systems, please email us at
            hello@inawo.com.
            <br />
            <br />
            In certain circumstances, you have the following data protection
            rights:
            <br />
            0.1. the right to access, update or to delete the information we
            have on you;
            <br />
            0.2. the right of rectification. You have the right to have your
            information rectified if that information is inaccurate or
            incomplete;
            <br />
            0.3. The right to object. You have the right to object to our
            processing of your Personal Data;
            <br />
            0.4. The right of restriction. You have the right to request that we
            restrict the processing of your personal information;
            <br />
            0.5. The right to data portability. You have the right to be
            provided with a copy of your Personal Data in a structured,
            machine-readable and commonly used format;
            <br />
            0.6. the right to withdraw consent. You also have the right to
            withdraw your consent at any time where we rely on your consent to
            process your personal information;
            <br />
            <br />
            Please note that we may ask you to verify your identity before
            responding to such requests. Please note, we may not be able to
            provide Service without some necessary data.
            <br />
            <br />
            You have the right to complain to a Data Protection Authority about
            our collection and use of your Personal Data. For more information,
            please contact your local data protection authority in the European
            Economic Area (EEA).
          </p>

          <h2 id="data-protection-CalOPPA">
            11. Your Data Protection Rights under the California Privacy
            Protection Act (CalOPPA)
          </h2>
          <p
            ref={(element) => {
              ref11.current = element;
            }}
          >
            CalOPPA is the first state law in the nation to require commercial
            websites and online services to post a privacy policy. The law’s
            reach stretches well beyond California to require a person or
            company in the United States (and conceivable the world) that
            operates websites collecting personally identifiable information
            from California consumers to post a conspicuous privacy policy on
            its website stating exactly the information being collected and
            those individuals with whom it is being shared, and to comply with
            this policy.
            <br />
            <br />
            According to CalOPPA we agree to the following:
            <br />
            0.1. users can visit our site anonymously;
            <br />
            0.2. our Privacy Policy link includes the word “Privacy”, and can
            easily be found on the homepage of our website;
            <br />
            0.3. users will be notified of any privacy policy changes on our
            Privacy Policy Page;
            <br />
            0.4. users are able to change their personal information by emailing
            us at <span className="bold">hello@inawo.com</span>.
            <br />
            <br />
            Our Policy on “Do Not Track” Signals:
            <br />
            <br />
            We honor Do Not Track signals and do not track, plant cookies, or
            use advertising when a Do Not Track browser mechanism is in place.
            Do Not Track is a preference you can set in your web browser to
            inform websites that you do not want to be tracked. You can enable
            or disable Do Not Track by visiting the Preferences or Settings page
            of your web browser.
          </p>

          <h2 id="data-protection-CCPA">
            12. Your Data Protection Rights under the California Consumer
            Privacy Act (CCPA)
          </h2>
          <p
            ref={(element) => {
              ref12.current = element;
            }}
          >
            If you are a California resident, you are entitled to learn what
            data we collect about you, ask to delete your data and not to sell
            (share) it. To exercise your data protection rights, you can make
            certain requests and ask us:
            <br />
            <br />
            <span className="bold">
              0.1. What personal information we have about you. If you make this
              request, we will return to you:
            </span>
            <br />
            0.0.1. The categories of personal information we have collected
            about you.
            <br />
            0.0.2. The categories of sources from which we collect your personal
            information.
            <br />
            0.0.3. The business or commercial purpose for collecting or selling
            your personal information.
            <br />
            0.0.4. The categories of third parties with whom we share personal
            information.
            <br />
            0.0.5. The specific pieces of personal information we have collected
            about you.
            <br />
            0.0.6. A list of categories of personal information that we have
            sold, along with the category of any other company we sold it to. If
            we have not sold your personal information, we will inform you of
            that fact.
            <br />
            0.0.7. A list of categories of personal information that we have
            disclosed for a business purpose, along with the category of any
            other company we shared it with.
            <br />
            Please note, you are entitled to ask us to provide you with this
            information up to two times in a rolling twelve-month period. When
            you make this request, the information provided may be limited to
            the personal information we collected about you in the previous 12
            months.
            <br />
            <br />
            <span className="bold">
              0.2. To delete your personal information. If you make this
              request, we will delete the personal information we hold about you
              as of the date of your request from our records and direct any
              service providers to do the same. In some cases, deletion may be
              accomplished through de-identification of the information. If you
              choose to delete your personal information, you may not be able to
              use certain functions that require your personal information to
              operate.
            </span>
            <br />
            <br />
            <span className="bold">
              0.3. To stop selling your personal information. We don&apos;t sell
              or rent your personal information to any third parties for any
              purpose. We do not sell your personal information for monetary
              consideration. However, under some circumstances, a transfer of
              personal information to a third party, or within our family of
              companies, without monetary consideration may be considered a
              “sale” under California law. You are the only owner of your
              Personal Data and can request disclosure or deletion at any time.
            </span>
            <br />
            <br />
            If you submit a request to stop selling your personal information,
            we will stop making such transfers.
            <br />
            <br />
            Please note, if you ask us to delete or stop selling your data, it
            may impact your experience with us, and you may not be able to
            participate in certain programs or membership services which require
            the usage of your personal information to function. But in no
            circumstances, we will discriminate against you for exercising your
            rights.
            <br />
            To exercise your California data protection rights described above,
            please send your request(s) by email:{" "}
            <span className="bold">hello@inawo.com</span>.
            <br />
            <br />
            Your data protection rights, described above, are covered by the
            CCPA, short for the California Consumer Privacy Act. To find out
            more, visit the official California Legislative Information website.
            The CCPA took effect on 01/01/2020.
          </p>

          <h2 id="service-providers">13. Service Providers</h2>
          <p
            ref={(element) => {
              ref13.current = element;
            }}
          >
            We may employ third party companies and individuals to facilitate
            our Service (“Service Providers”), provide Service on our behalf,
            perform Service-related services or assist us in analysing how our
            Service is used.
            <br />
            <br />
            These third parties have access to your Personal Data only to
            perform these tasks on our behalf and are obligated not to disclose
            or use it for any other purpose.
          </p>

          <h2 id="analytics">14. Analytics</h2>
          <p
            ref={(element) => {
              ref14.current = element;
            }}
          >
            We may use third-party Service Providers to monitor and analyse the
            use of our Service
          </p>

          <h2 id="cicd-tools">15. CI/CD tools</h2>
          <p
            ref={(element) => {
              ref15.current = element;
            }}
          >
            We may use third-party Service Providers to automate the development
            process of our Service.
          </p>

          <h2 id="behavioural-remarketing">16. Behavioural Remarketing</h2>
          <p
            ref={(element) => {
              ref16.current = element;
            }}
          >
            We may use remarketing services to advertise on third party websites
            to you after you visited our Service. We and our third-party vendors
            use cookies to inform, optimise and serve ads based on your past
            visits to our Service.
          </p>

          <h2 id="payments">17. Payments</h2>
          <p
            ref={(element) => {
              ref17.current = element;
            }}
          >
            We may provide paid products and/or services within Service. In that
            case, we use third-party services for payment processing (e.g.
            payment processors).
            <br />
            <br />
            Information on your payment card details may be collected and
            provided directly to our third-party payment processors whose use of
            your personal information is governed by their Privacy Policy. These
            payment processors adhere to the standards set by PCI-DSS as managed
            by the PCI Security Standards Council, which is a joint effort of
            brands like Visa, Mastercard, American Express and Discover. PCI-DSS
            requirements help ensure the secure handling of payment information.{" "}
          </p>

          <h2 id="links-to-sites">18. Links to Other Sites</h2>
          <p
            ref={(element) => {
              ref18.current = element;
            }}
          >
            Our Service may contain links to other sites that are not operated
            by us. If you click a third party link, you will be directed to that
            third party’s site. We strongly advise you to review the Privacy
            Policy of every site you visit.
            <br />
            We have no control over and assume no responsibility for the
            content, privacy policies or practices of any third party sites or
            services.
          </p>

          <h2 id="children-privacy">19. Children&apos;s Privacy</h2>
          <p
            ref={(element) => {
              ref19.current = element;
            }}
          >
            Our Services are not intended for use by children under the age of
            16 (“<span className="bold">Child</span>” or “
            <span className="bold">Children</span>”).
            <br />
            We do not knowingly collect personally identifiable information from
            Children under 16. If you become aware that a Child has provided us
            with Personal Data, please contact us. If we become aware that we
            have collected Personal Data from Children without verification of
            parental consent, we take steps to remove that information from our
            servers.
          </p>

          <h2 id="dprivacy-policy-changes">
            20. Changes to This Privacy Policy
          </h2>
          <p
            ref={(element) => {
              ref20.current = element;
            }}
          >
            We may update our Privacy Policy from time to time. We will notify
            you of any changes by posting the new Privacy Policy on this page.
            <br />
            <br />
            We will let you know via email and/or a prominent notice on our
            Service, prior to the change becoming effective and update
            “effective date” at the top of this Privacy Policy.
            <br />
            You are advised to review this Privacy Policy periodically for any
            changes. Changes to this Privacy Policy are effective when they are
            posted on this page.
          </p>

          <h2 id="contact-us">21. Contact Us</h2>
          <p
            ref={(element) => {
              ref21.current = element;
            }}
          >
            Please send your feedback, comments, requests for technical support
            by email: <a href="mailto:hello@inawo.co">hello@inawo.co</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
